// extracted by mini-css-extract-plugin
module.exports = {"heading":"Form_heading__jGWeF","searcher":"Form_searcher__24vsO","mw500":"Form_mw500__3-TdH"};